import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  spacing4,
  spacing8,
  spacing16,
} from 'approot/shared/styles/spacing.style';
import {
  green1,
  green7,
  grey3,
  grey5,
  grey6,
  grey9,
  purple1,
  purple7,
  red1,
  red7,
  red9,
} from 'approot/shared/styles/colours.style';
import { PStyled } from 'approot/shared/styles/typography.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { baseFlexCss } from 'approot/shared/styles/flex.style';
import {
  ItemsPerRowProps,
  MultipleChoiceLetter,
  OptionSizeProps,
  optionSize,
} from './multiple-choice.style';
import { useActivityBuilderFontStyles } from 'approot/activity-builder/theme/activity-builder-theme.style';

export const MultipleChoiceButtonText = styled(PStyled).attrs({
  as: 'span',
  marginBottom: 0,
})`
  ${() =>
    useActivityBuilderFontStyles({
      isSmall: true,
    })}
  white-space: pre-wrap;
  text-align: left;
  overflow-wrap: anywhere;
`;

type MultipleChoiceStyleProps = {
  $hasMarginRight?: boolean;
  $isText?: boolean;
  $isCorrect?: boolean;
  $isIncorrect?: boolean;
  $isSelected?: boolean;
  $isDisabled?: boolean;
  $isPartiallyCorrect?: boolean;
} & OptionSizeProps &
  ItemsPerRowProps;

export const MultipleChoiceItem = styled.div<MultipleChoiceStyleProps>`
  ${optionSize}

  border: 1px solid ${grey5};
  display: flex;
  border-radius: ${rem(borderRadius8)};
  margin-bottom: ${rem(spacing8)};
  padding: ${({ $isText }) => ($isText ? rem(spacing16) : rem(spacing4))};
  position: relative;
  float: left;
  width: calc(
    (100% - ((${({ $itemsPerRow }) => $itemsPerRow} - 1) * 8px)) /
      ${({ $itemsPerRow }) => $itemsPerRow}
  );

  ${({ $hasMarginRight }) =>
    $hasMarginRight &&
    `
    margin-right: ${rem(spacing8)};
  `}

  ${({ $isCorrect }) =>
    $isCorrect &&
    `
      background-color: ${green1};
      border-color: ${green7};
      box-shadow: 0 0 0 1px ${green7};

      &:focus {
        box-shadow: 0 0 0 2px ${green7};
        border-color: ${green7};
      }
    `}

  ${({ $isIncorrect }) =>
    $isIncorrect === true &&
    `
      background-color: ${red1};
      border-color: ${red7};
      box-shadow: 0 0 0 1px ${red7};

      &:focus {
        box-shadow: 0 0 0 2px ${red7};
        border-color: ${red9};
      }
    `}

  ${({ $isSelected }) =>
    $isSelected &&
    `
      background-color: ${purple1};
      border-color: ${purple7};
      box-shadow: 0 0 0 1px ${purple7};

      &:focus {
        box-shadow: 0 0 0 2px ${purple7};
        border-color: ${purple7};
      }
    `}

  ${({ $isDisabled, $isPartiallyCorrect }) =>
    ($isDisabled === true || $isPartiallyCorrect === true) &&
    `
      background-color: ${grey3};
      border-color: ${grey5};
      box-shadow: none;
      color: ${grey6};

      &:active {
        box-shadow: none;
      }

      &:focus {
        box-shadow: 0 0 0 2px ${grey9};
        border-color: ${grey6};
      }
      
      ${MultipleChoiceLetter} {
        background-color: ${grey3};
      }

      &:before {
        content: '';
        background-color: rgba(0,0,0,0.05);
        border-radius: ${rem(borderRadius8)};
        position: absolute;
        top: ${rem(spacing4)};
        bottom: ${rem(spacing4)};
        left: ${rem(spacing4)};
        right: ${rem(spacing4)};
        z-index: 1;
      }
    `}
`;

export const MultipleChoicePrintContent = styled.div`
  ${baseFlexCss}
  width: 100%;
  position: relative;
`;

type MultipleChoiceButtonsProps = {
  $display: string;
  $isNoWrap: boolean;
};
export const MultipleChoiceButtons = styled.div<MultipleChoiceButtonsProps>`
  margin-bottom: -${rem(spacing8)};
  &:after {
    content: '';
    clear: both;
    display: block;
  }
`;

export const MultipleChoicePrintImage = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
`;

export const MultipleChoicePrintTextContent = styled.div`
  ${baseFlexCss}
  width: 100%;
`;
